module.exports = __webpack_public_path__ + "img/public-new-knowledge.89f7c273.png";